import { renderLoginScreen, checkAuth } from './auth/gate.js';
import { auth } from './state/app-state.js';
import { SignController } from './sign/sign-controller.js';
import { Workspace } from './controls/workspace.js';
import { mountProgressBar } from './controls/progress-bar.js';
import { clearCookie, readCookie } from './util/cookies.js';

const rootEl = document.querySelector<HTMLDivElement>('#app');
if (!rootEl) throw new Error('missing #app');
const root: HTMLDivElement = rootEl;

async function renderWorkspace(): Promise<void> {
  root.innerHTML = `
    <div id="stage-host"></div>
    <div id="controls-host" class="controls"></div>`;
  const sign = new SignController(root.querySelector<HTMLDivElement>('#stage-host')!);
  const workspace = new Workspace(sign, root.querySelector<HTMLDivElement>('#controls-host')!);
  if (!document.querySelector('.global-status')) mountProgressBar(document.body);
  const cookieKey = readCookie('sgt_prospect');
  if (cookieKey) {
    const ok = await workspace.hydrateIfPossible(cookieKey);
    if (!ok) clearCookie('sgt_prospect');
  }
}

async function bootstrap() {
  if (await checkAuth()) { auth.set('authed'); await renderWorkspace(); return; }
  auth.set('login');
  renderLoginScreen(root, () => { void renderWorkspace(); });
}

void bootstrap();
